var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{attrs:{"fixed":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_c('router-link',{staticClass:"p-2",attrs:{"target":"_blank","to":"/"}},[_vm._v(_vm._s(_vm.appName())+" "),_c('v-icon',[_vm._v("mdi mdi-web")])],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }